import { Modal } from '@mantine/core';
import PropTypes from 'prop-types';
import React from 'react';
import FormSettingManualTransaction from '../../forms/FormSettingManualTransaction';
import FormSettingManualTransactionBulk from '../../forms/FormSettingManualTransactionBulk';
import styles from './styles.scoped.css';

export default function ModalSettingManualActivation({
  type,
  data,
  dataDetailUser,
  onClose,
  handleSubmit,
  open,
  // reason = '',
  // values = {}
}){
  const content = {
    'one' : {
      title: 'Ubah Pengaturan',
      subtitle: (
        <>
          Ubah pengaturan waktu dan status Kelurahan {' '}
          <strong>{data?.villageName}</strong>?
        </>
      ),
      component: <FormSettingManualTransaction
        data={data}
        handleClose={onClose}
        handleSubmit={handleSubmit}
        type={type}
      />,
      footer: null
    },
    'bulk' : {
      title: 'Ubah Pengaturan Sekaligus',
      subtitle: '',
      component: <FormSettingManualTransactionBulk
        dataDetailUser={dataDetailUser}
        handleClose={onClose}
        handleSubmit={handleSubmit}
        requestId={data?.data?.requestId}
        type={type}
      />,
      footer: null
    },
  };

  return (
    <Modal
      onClose={onClose}
      opened={open}
      size={'lg'}
    >
      <div className={styles.modalContent}>
        <h4>{content[type]?.title}</h4>
        <p>{content[type]?.subtitle}</p>
        {content[type]?.component}
      </div>
      {content[type]?.footer}
    </Modal>
  );
}


ModalSettingManualActivation.propTypes = {
  data: PropTypes.object,
  dataDetailUser: PropTypes.object,
  handleSubmit: PropTypes.func,
  onClose: PropTypes.func,
  open: PropTypes.bool,
  reason: PropTypes.string,
  type: PropTypes.oneOf([
    'one',
    'bulk',
  ]),
  values: PropTypes.object,
};

